export const FORM_TYPE_MAP = {
    INPUT: 'textarea',
    RADIO: 'radio',
    CHECKBOX: 'checkbox',
};

export const QA_LANG_KEY_PRE = {
    0: '',
    1: 'tc_',
    2: 'en_',
    5: 'ja_',
};
